import { render, staticRenderFns } from "./SelectAutocomplete.vue?vue&type=template&id=ef96e3ba"
import script from "./SelectAutocomplete.vue?vue&type=script&lang=ts"
export * from "./SelectAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports